import React, { Component, Fragment} from 'react'
import { Link } from 'react-router-dom'
import { Content } from './styles'
import ProjectGroup from '../ProjectGroup'
import Navigation from '../Navigation'
import users from '../../Data/users'

class Feed extends Component {
  constructor() {
    super()
    this.state = {
      user: null
    }
  }

  componentDidMount () {
    let user = users.filter((user,index) => { return user.username === this.props.match.params.username})
    this.setState(() => ({ user: {...user[0]} }))
  }

  render() {
    return(
      <Content>
        { this.state.user && this.state.user.projects ? (
            <Fragment>
              <Navigation user={this.state.user} />
              <ProjectGroup projects={this.state.user.projects} />
            </Fragment>
          ) : (
            <Fragment>
              <h1>Nothingless.</h1>
              <p>Looks like these folders are either classified or were destroyed.</p>
              <p><Link to={`/`}>Take a step back.</Link></p>
            </Fragment>
          )
        }
      </Content>
    )
  }
}

export default Feed



// WEBPACK FOOTER //
// ./src/Components/Feed/index.js